import utilsProvider from '../../../providers/utils.provider';
import { CAPTION_CLASS } from '../financial.type.component';

const SELECT_CLASS = 'text-sm font-medium text-[#1d1d1f] bg-white border border-[#dddddd] rounded-lg px-2 py-1.5 max-w-[260px]';
const LABEL_CLASS = ['flex flex-col gap-1', CAPTION_CLASS].join(' ');

const servicesOf = (pieceOptions) => pieceOptions
    .reduce((services, option) => services.some(service => service.serviceId === option.serviceId)
        ? services
        : services.concat({ serviceId: option.serviceId, serviceName: option.serviceName }), []);

const variantsOf = (pieceOptions, serviceId) => pieceOptions
    .filter(option => option.serviceId === serviceId && option.calculationServiceId);

const ServiceSelect = ({ services, value, onPick }) => (
    <label className={LABEL_CLASS}>
        Que peça entrou
        <select className={SELECT_CLASS} value={value || ''} onChange={event => onPick(Number(event.target.value))}>
            {services.map(service => (
                <option key={service.serviceId} value={service.serviceId}>{service.serviceName}</option>
            ))}
        </select>
    </label>
);

const VariantSelect = ({ variants, value, onPick }) => (
    <label className={LABEL_CLASS}>
        De que tipo
        <select className={SELECT_CLASS} value={value || ''} onChange={event => onPick(Number(event.target.value))}>
            {variants.map(variant => (
                <option key={variant.calculationServiceId} value={variant.calculationServiceId}>
                    {variant.calculationServiceName}
                </option>
            ))}
        </select>
    </label>
);

const priceSentence = (option) => option
    ? `Esta peça vale ${utilsProvider.formatNumberCurrency(option.customerPrice)} para o cliente e ${utilsProvider.formatNumberCurrency(option.faciliterBasePrice)} para o faciliter.`
    : 'O pacote deste cliente não cobre esta peça, então ela não pode ser lançada.';

export default function AdjustmentPiecePicker({ pieceOptions, entry, option, onChange }) {

    const variants = variantsOf(pieceOptions, entry.serviceId);

    const pickService = (serviceId) => {
        const [firstVariant] = variantsOf(pieceOptions, serviceId);
        onChange({ serviceId, calculationServiceId: firstVariant ? firstVariant.calculationServiceId : null });
    };

    return (
        <div className="mt-3 p-3 rounded-lg border border-[#dddddd] bg-white flex flex-wrap items-end gap-3">
            <ServiceSelect services={servicesOf(pieceOptions)} value={entry.serviceId} onPick={pickService} />

            {variants.length > 0 && (
                <VariantSelect
                    variants={variants}
                    value={entry.calculationServiceId}
                    onPick={calculationServiceId => onChange({ serviceId: entry.serviceId, calculationServiceId })}
                />
            )}

            <p className="basis-full m-0 text-xs text-gray-500 leading-relaxed">{priceSentence(option)}</p>
        </div>
    );
}
